import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../../Search/Search";
import Title from "../../../common/Title";
import BatchList from "../../../common/BatchList";

import useBatchListState from "../../../../hooks/useBatchListState";
import { __getSimInfoBatches } from "../../../../api/sim";
import { OPERATIONS } from "../../../../constants/value";

const ClientSimInfo = () => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getSimInfoBatches);

  return (
    <Box sx={{ width: "100%" }}>
      <Title variant="h5" content="Sim Information" gutterBottom />
      <Search
        key={`sim_info`}
        operation={OPERATIONS.sim_info}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              {response && (
                <Grid item>
                  <Stack spacing={2} mb={2} direction="row">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => nav("form")}
                    >
                      Fetch Sim Info
                    </Button>
                  </Stack>
                </Grid>
              )}
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default ClientSimInfo;
